import {
  FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_NETWORKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_LINKS_LIST,
  FETCH_SOCIAL_LINKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_LINKS_LIST,
  CREATE_SOCIAL_LINK_SUCCESS,
  CREATE_SOCIAL_LINK_ERROR,
  CLEAR_CREATE_SOCIAL_LINK,
  PATCH_SOCIAL_LINK_SUCCESS,
  PATCH_SOCIAL_LINK_ERROR,
  CLEAR_PATCH_SOCIAL_LINK,
  DELETE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK_ERROR,
  CLEAR_DELETE_SOCIAL_LINK,
  APPLY_SOCIAL_LINK_DRAG,
  APPLY_SOCIAL_LINK_DRAG_ERROR,
  CLEAR_SOCIAL_LINK_DRAG,
} from 'redux/social/types';

const initialState = {
  socialNetworksList: null,
  socialNetworksListError: null,
  socialLinksList: null,
  socialLinksListError: null,
  createSocialLinkSuccess: null,
  createSocialLinkError: null,
  patchSocialLinkSuccess: null,
  patchSocialLinkError: null,
  deleteSocialLinkSuccess: null,
  deleteSocialLinkError: null,
  socialLinkDrugSuccess: null,
  socialLinkDrugError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SOCIAL_NETWORKS_LIST:
      return {
        ...state,
        socialNetworksList: action.payload.data,
        socialNetworksListError: null,
      };
    case FETCH_SOCIAL_NETWORKS_LIST_ERROR:
      return {
        ...state,
        socialNetworksList: null,
        socialNetworksListError: action.payload.data,
      };
    case CLEAR_FETCH_SOCIAL_NETWORKS_LIST:
      return {
        ...state,
        socialNetworksList: null,
        socialNetworksListError: null,
      };
    case FETCH_SOCIAL_LINKS_LIST:
      return {
        ...state,
        socialLinksList: action.payload.data,
        socialLinksListError: null,
      };
    case FETCH_SOCIAL_LINKS_LIST_ERROR:
      return {
        ...state,
        socialLinksList: null,
        socialLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_SOCIAL_LINKS_LIST:
      return {
        ...state,
        socialLinksList: null,
        socialLinksListError: null,
      };
    case CREATE_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        createSocialLinkSuccess: action.payload.data,
        createSocialLinkError: null,
      };
    case CREATE_SOCIAL_LINK_ERROR:
      return {
        ...state,
        createSocialLinkSuccess: null,
        createSocialLinkError: action.payload.data,
      };
    case CLEAR_CREATE_SOCIAL_LINK:
      return {
        ...state,
        createSocialLinkSuccess: null,
        createSocialLinkError: null,
      };
    case PATCH_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        patchSocialLinkSuccess: action.payload.data,
        patchSocialLinkError: null,
      };
    case PATCH_SOCIAL_LINK_ERROR:
      return {
        ...state,
        patchSocialLinkSuccess: null,
        patchSocialLinkError: action.payload.data,
      };
    case CLEAR_PATCH_SOCIAL_LINK:
      return {
        ...state,
        patchSocialLinkSuccess: null,
        patchSocialLinkError: null,
      };
    case DELETE_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        deleteSocialLinkSuccess: action.payload.data,
        deleteSocialLinkError: null,
      };
    case DELETE_SOCIAL_LINK_ERROR:
      return {
        ...state,
        deleteSocialLinkSuccess: null,
        deleteSocialLinkError: action.payload.data,
      };
    case CLEAR_DELETE_SOCIAL_LINK:
      return {
        ...state,
        deleteSocialLinkSuccess: null,
        deleteSocialLinkError: null,
      };
    case APPLY_SOCIAL_LINK_DRAG:
      return {
        ...state,
        socialLinkDrugSuccess: action.payload.data,
        socialLinkDrugError: null,
      };
    case APPLY_SOCIAL_LINK_DRAG_ERROR:
      return {
        ...state,
        socialLinkDrugSuccess: null,
        socialLinkDrugError: action.payload.data,
      };
    case CLEAR_SOCIAL_LINK_DRAG:
      return {
        ...state,
        socialLinkDrugSuccess: null,
        socialLinkDrugError: null,
      };
    default:
      return state;
  }
};
